import { render } from "./KeikakumeisaiFoldableCost.vue?vue&type=template&id=2a6d87d1"
import script from "./KeikakumeisaiFoldableCost.vue?vue&type=script&lang=js"
export * from "./KeikakumeisaiFoldableCost.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__